var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{clip-path:url(#SVGID_00000079450676113016085300000018231465086528626874_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M46.51,9.31c-1.93,0-3.5,1.57-3.5,3.5c0,0,0,0,0,0v8.58H7v-8.58c-0.06-1.93-1.67-3.45-3.6-3.4 c-1.85,0.05-3.34,1.54-3.4,3.4v24.17c-0.06,1.93,1.46,3.55,3.4,3.6c1.93,0.06,3.55-1.46,3.6-3.4c0-0.07,0-0.14,0-0.21V28.4h36v8.58 c-0.11,1.93,1.36,3.59,3.29,3.7c1.93,0.11,3.59-1.36,3.7-3.29c0.01-0.14,0.01-0.27,0-0.41V12.81C49.99,10.89,48.43,9.32,46.51,9.31 "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRange);
export default __webpack_public_path__ + "static/media/Icon_Range.f1d73ee52a9ba58879e32758e3639d08.svg";
export { ForwardRef as ReactComponent };